import React from 'react'
import { Grid, Autocomplete, TextField } from '@mui/material'
import { SCOPES } from 'components'

const options = Object.keys(SCOPES).flatMap((scope) => {
  const item = SCOPES[scope]

  const itemOption = []
  if ('Write' in item) {
    itemOption.push({
      label: `${item.Name} - Write`,
      id: item.Write,
      name: item.Name
    })
  }
  itemOption.push({
    label: `${item.Name} - Read`,
    id: item.Read,
    name: item.Name
  })
  return itemOption
})

export const RolePermissions = ({ role, setErrors, setRole, errors }) => {
  return (
    <Grid container item width="100%">
      <Grid width="100%" item>
        <Autocomplete
          options={options}
          value={role.scopes}
          disableCloseOnSelect
          multiple
          includeInputInList={false}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          onChange={(_, value, reason) => {
            setErrors((errors) => {
              return {
                ...errors,
                scopes: undefined
              }
            })
            let allSelected = value
            if (reason === 'removeOption') {
              const selectedIds = value.map((selected) => selected.id)
              const removedOption = role.scopes.find((scope) => !selectedIds.includes(scope.id))
              if (removedOption.label.includes('Read')) {
                allSelected = value.filter((selected) => selected.name !== removedOption.name)
              }
            } else if (reason === 'selectOption') {
              const selected = allSelected[allSelected.length - 1]
              if (selected.label.includes('Write')) {
                const name = selected.label.name
                if (!allSelected.find((item) => item.name === name && item.id.includes('Read'))) {
                  const readOption = options.find(
                    (item) => item.name === selected.name && item.id === `${selected.name}.Read`
                  )
                  allSelected.push(readOption)
                }
              }
            }

            setRole((role) => {
              return {
                ...role,
                scopes: allSelected
              }
            })
          }}
          renderInput={(params) => (
            <TextField error={!!errors.scopes} {...params} label="Select role scopes" variant="standard" />
          )}
        />
      </Grid>
    </Grid>
  )
}
